import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { AboutSection } from "@/components/AboutSection";
import { SocialProofStrip } from "@/components/SocialProofStrip";
import { CategoriesPage } from "@/components/CategoriesPage";
import { CategoryPage } from "@/components/CategoryPage";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { ProductDetail } from "@/components/ProductDetail";
import { PaymentResult } from "@/components/PaymentResult";

// react-router no maneja hashes ni resetea el scroll: al cambiar de ruta
// subimos al top, y si la URL trae #hash hacemos scroll a esa sección.
const ScrollManager = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);
  return null;
};

const Home = () => {
  return (
    <div
      data-testid="home-page"
      className="min-h-screen bg-slate-50 text-slate-900 font-sans antialiased"
    >
      <Navbar />
      <CartDrawer />
      <main>
        <HeroSection />
        <AboutSection />
        <SocialProofStrip />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/categorias" element={<CategoriesPage />} />
          <Route path="/categoria/:slug" element={<CategoryPage />} />
          <Route path="/producto/:id" element={<ProductDetail />} />
          <Route path="/pagos/resultado" element={<PaymentResult />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        richColors
        closeButton
        toastOptions={{
          style: {
            fontFamily: "Nunito, sans-serif",
          },
        }}
      />
    </CartProvider>
  );
}

export default App;
